import AppContext from 'services/context';

import Routes from './routes';
import { GlobalStyles } from './theme/styles.App';
import { theme } from './theme/theme';

import React from 'react';
import ReactGA from 'react-ga4';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

const GA_ID = process.env.REACT_APP_GA_ID;
if (GA_ID) {
  ReactGA.initialize(GA_ID);
}

/**
 * Componente principal da aplicação
 * Configura providers de contexto, tema e roteamento
 */
export default class App extends React.Component {
  render() {
    return (
      <AppContext.Provider value={{}}>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <Router>
            <Routes />
          </Router>
        </ThemeProvider>
      </AppContext.Provider>
    );
  }
}
